// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YIHvH","caraPop":"styles_caraPop__6WcRb","check":"styles_check__Jv5mX","title":"styles_title__34HU_","text":"styles_text__Jn1Y5"};